module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"ХаниМани","slogan":"Миру — мир! #нетвойне"},"en":{"title":"HoneyMoney","slogan":"Be<span style=\u0027opacity: 0.3;\u0027>e</span> good with money!"}}')
  delete Component.options._Ctor
}
